import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Shield, Globe, Rocket } from 'lucide-react';
import './Services.css';

const Services = () => {
  const organizations = [
    {
      id: 'futures',
      name: 'Partsol Futures',
      tagline: 'Strategic Innovation Lab',
      description: 'The strategic innovation arm of Partsol focused on accelerating breakthrough applications of Cognitive AI. We drive the development of deployable, enterprise-grade AI solutions across national security, smart infrastructure, life sciences, and advanced education.',
      icon: <Rocket size={48} />,
      features: [
        'Breakthrough AI Research',
        'Enterprise-Grade Solutions',
        'Smart Infrastructure',
        'Life Sciences Applications'
      ],
      color: '#AE8735'
    },
    {
      id: 'defense',
      name: 'Partsol Defense',
      tagline: 'National Security Solutions',
      description: 'Dedicated to supporting defense and intelligence communities with Cognitive AI solutions that enhance decision-making in critical national security environments. We deliver precision-driven intelligence for mission-critical operations.',
      icon: <Shield size={48} />,
      features: [
        'Defense Intelligence',
        'Counterterrorism Support',
        'Cybersecurity Solutions',
        'Mission-Critical Operations'
      ],
      color: '#2E4364'
    },
    {
      id: 'global',
      name: 'Partsol Global',
      tagline: 'Enterprise Solutions Worldwide',
      description: 'Responsible for operational strategy and management of Partsol\'s global enterprise solutions. We serve Fortune 500 companies and government agencies with Cognitive AI platforms that transform complex data into actionable intelligence.',
      icon: <Globe size={48} />,
      features: [
        'Global Enterprise Deployment',
        'Fortune 500 Partnerships',
        'Government Solutions',
        'Supply Chain Intelligence'
      ],
      color: '#051D34'
    }
  ];

  return (
    <div className="services-page">
      <section className="services-hero">
        <div className="services-hero-content">
          <p className="services-hero-label">Our Organizations</p>
          <h1 className="services-hero-title">Three Pillars of Cognitive AI Excellence</h1>
          <p className="services-hero-subtitle">
            Partsol operates through three specialized organizations, each focused on delivering 
            Cognitive AI solutions tailored to specific sectors and challenges.
          </p>
        </div>
      </section>

      <section className="services-organizations">
        {organizations.map((org, index) => (
          <div key={org.id} className={`org-section ${index % 2 === 1 ? 'reverse' : ''}`}>
            <div className="org-content">
              <div className="org-icon" style={{ backgroundColor: org.color }}>
                {org.icon}
              </div>
              <p className="org-tagline">{org.tagline}</p>
              <h2 className="org-name">{org.name}</h2>
              <p className="org-description">{org.description}</p>
              <ul className="org-features">
                {org.features.map((feature, i) => (
                  <li key={i}>
                    <span className="feature-dot" style={{ backgroundColor: org.color }}></span>
                    {feature}
                  </li>
                ))}
              </ul>
              <Link to="/contact" className="org-cta">
                Learn More <ArrowRight size={18} />
              </Link>
            </div>
            <div className="org-visual">
              <div className="org-visual-bg" style={{ backgroundColor: org.color }}></div>
              <div className="org-visual-content">
                <span className="org-number">0{index + 1}</span>
              </div>
            </div>
          </div>
        ))}
      </section>

      <section className="services-cta">
        <div className="services-cta-container">
          <h2>Ready to Transform Your Decision-Making?</h2>
          <p>Contact us to learn how our Cognitive AI solutions can address your specific challenges.</p>
          <Link to="/contact" className="services-cta-button">
            Get in Touch <ArrowRight size={18} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Services;
